export const DynamicFieldsTypesNames = {
  CHECKBOX: 'Checkbox',
  FLOW_SELECTION: 'FlowSelection',
} as const;
